<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <h1>{{groupPluralName}}</h1>
      <div class="left-tools no-select">
        <input type="checkbox" id="showGroups" name="showGroups" v-model="showThisYearGroups" @change="setGroupsGlobal()">
        <label for="showGroups">Show only this year's groups</label>
      </div>
      <div class="right-tools no-select">
        <span class="sorting" v-on:click.stop="toggleSort()">Sort by Name <i v-if="reverseSort" class="fal fa-chevron-up"></i><i v-else class="fal fa-chevron-down"></i></span>
        <Popover ref="popoverGroupToken" content="popover" placement="bottom">
          <div class="icon-button" ref="addGroupCodeBtn"><i class="fal fa-plus"></i></div>
          <div slot="content">
            <div class="list-item" v-on:click.stop="groupAction('groupCode')">
              <span class="popover-list-image">
                <i class="fal fa-users"></i>
              </span>
              <span class="action-item">Add group</span>
            </div>
          </div>
        </Popover>
      </div>
      <div style="clear: both;"></div>

      <div v-if="popoverOptions.groupCodeModalActive" @click="closeAllPopover" class="modal no-select">
        <div class="modal-content" @click.stop=";">
          <h3 class="has-text-left">Add group</h3>
          <p class="has-text-left">Please enter the group token code provided to you.</p>
          <form v-on:submit.prevent="submitGroupCode">
            <input type="text" v-model="groupCode">
          </form>
          <p class="error has-text-left has-text-danger" v-if="error">{{error}}</p>
          <div class="modal-buttons is-pulled-right">
            <button class="button" v-on:click.stop="closeAllPopover">Cancel</button>
            <button class="button is-primary" :disabled="groupCode === ''" v-on:click.stop="submitGroupCode">Submit</button>            
          </div>
        </div>
      </div>

      <AppWideSearch 
        v-if="showAppWideSearch"
        searchPlaceholder="Search"
        @appWideSearchActive="onAppWideSearchActive"/>

      <div v-if="groups.length === 0" class="no-content-message">
        There are currently no groups to display.
      </div>

      <slot v-if="!appWideSearchEnable">
        <router-link :to="'group/' + group.code" v-for="(group, i) in filteredGroups" v-bind:key="i">
          <div class="group">
            <div class="group-color" :style="{background: utils.stringToBgRGBAColor(group.code)}"></div> 
            <span class="group-name">{{group.name}}</span>
            <span v-if="group.blueDot" class="unread">{{group.blueDot}}</span>
            
          </div>
        </router-link>
      </slot>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue';
  import utils from '@/utils/utils.js';
  import error from '@/utils/error.js';
  import AppWideSearch from './AppWideSearch';
  import analytics from '@/utils/analytics.js';
  import Popover from '@/components/widgets/popover';
  import storeHelpers from '@/utils/storeHelpers.js';
  import configUtils from "@/utils/configUtils";
  
  export default {
    name: 'Groups',
    components: {
      AppWideSearch,
      Popover
    },
    computed: {
      filteredGroups() {
        var t = this
        if (t.showThisYearGroups) {
          return _.filter(t.groups, group => {
            if (group.end < new Date(new Date().getFullYear(), 0, 1).getTime() / 1000)
              return false
            else 
              return true
          })
        } else return t.groups
      }
    },
    data: function () {
      var t = this;

      return {
        loading: true,
        groups: [],
        utils: utils,
        groupPluralName: 'Groups',
        reverseSort: false,
        search: '',
        popoverOptions: {
          groupCodeModalActive: false
        },
        groupCode: '',
        error: '',
        appWideSearchEnable: false,
        showAppWideSearch: true,
        showThisYearGroups: true
      }
    },
    destroyed: function() {
      this.unwatchFunction();
    },
    mounted: function () {
      var t = this
      configUtils.getSettingsProperty(this, "featureControl").then(features => {
        t.showAppWideSearch = features.appWideSearch;
      })
      .catch(error => {
        t.error = "Couldn't get feature list"
        console.error(error);
      })
      this.groupPluralName = utils.getNavName('041fef2f-90d2-448b-ac74-dad28e955612', this, true, 'Groups')
      this.unwatchFunction = utils.watchStoreProperty(this, 'groups', this.groupsUpdated);
      analytics.groupList(this);
      storeHelpers.checkActive(this);
      var t = this;
      document.addEventListener("keydown", function(e) {
        if (e.keyCode === 27) {
          t.closeAllPopover();
        }
      });
      // check state if sort settings set
      var groupsSettings = storeHelpers.getUserPreferences(this, "groups");
      if (groupsSettings) {
        this.reverseSort = groupsSettings.reverseSort;
        if (groupsSettings.toggleThisYear != undefined)
          this.showThisYearGroups = groupsSettings.toggleThisYear;
        else
          this.showThisYearGroups = true;
      }
    },
    methods: {
      groupsUpdated: function(groups) {
        this.groups = groups;
        var t = this
        
        configUtils.getSettingsProperty(this, "featureControl").then(features => {
          if (features.blueDots) {
            t.calculateBlueDots();
          }
        })
        .catch(error => {
          t.error = "Couldn't get feature list"
          console.error(error);
        })
          
        this.sort();
        this.loading = false;
      },
      calculateBlueDots: function() {
        var t = this;

        var allAttachments = t.$store.state.attachments;
        var resourcesById = _.keyBy(t.$store.state.resources, '_id');

        _.each(t.groups, group => {
          var attachmentsForGroup = [];
          const attachmentsForLP = storeHelpers.getAttachmentsForLP(this, group._id);
          const booksForGroup = storeHelpers.getBooks(this, group.code);

          // add attachments from appropriate books
          _.each(booksForGroup, book => {
            const attachmentsForBook = _.filter(allAttachments, att => att.book && att.book === book.id);
            if(attachmentsForBook) {
              attachmentsForGroup = attachmentsForGroup.concat(attachmentsForBook);
            }
          });

          // add attachments from lp
          attachmentsForGroup = attachmentsForGroup.concat(attachmentsForLP);

          // ensure the attachment list is unique by attachment id
          const uniqueAttachments = _.uniq(attachmentsForGroup, '_id');
          const uniqueAttachmentsPerResource = _.groupBy(uniqueAttachments, "resource");

          var uniqueUnreadAttachments = [];

          _.each(uniqueAttachmentsPerResource, function(attachments, resourceId) {
            var unreadSet = storeHelpers.getInstancesForResourceAttachmentSet(attachments, resourcesById[resourceId]);
            unreadSet = _.filter(unreadSet, resourceWithAtt => !resourceWithAtt.resource.private && resourceWithAtt.isUnread && resourceWithAtt.resource.category && !utils.isAnnotation(resourceWithAtt.resource));
            uniqueUnreadAttachments = uniqueUnreadAttachments.concat(unreadSet);
          });
          
          group.blueDot = uniqueUnreadAttachments.length;
        });
      },
      toggleSort: function () {
        this.reverseSort = !this.reverseSort;
        this.sort();
        var groupsSettings = storeHelpers.getUserPreferences(this, "groups");
        groupsSettings["reverseSort"] = this.reverseSort
        storeHelpers.setUserPreferences(this, "groups", groupsSettings);
      },
      sort: function() {
        var t = this;
        t.groups = _.orderBy(t.groups, [ function(group) { return group.name.trim().toLowerCase();} ], [t.reverseSort ? 'desc' : 'asc']);
      },
      groupAction: function(item) {
        var t = this;
        this.$refs.popoverGroupToken.hidePopper();
        if (item === "groupCode") {
          t.popoverOptions.groupCodeModalActive = !t.popoverOptions.groupCodeModalActive;
        }
      },
      closeAllPopover: function() {
        Vue.set(this.popoverOptions, 'groupCodeModalActive', false);
        this.groupCode = '';
      },
      submitGroupCode: function() {
        var t = this;
        var url = t.$config.get('ecApi') + "groups/token";
        
        axios.post(url, {
          token: t.groupCode
        }).then(response => {
          // todo?
        }).catch(e => {
          t.error = error.logAndGetError(t, e);
        })
      },
      onAppWideSearchActive: function(val) {
        this.appWideSearchEnable = val.length > 0 ? true : false;
      },
      setGroupsGlobal() {
        var groupsSettings = storeHelpers.getUserPreferences(this, "groups");
        groupsSettings["toggleThisYear"] = this.showThisYearGroups
        storeHelpers.setUserPreferences(this, "groups", groupsSettings);

        // storeHelpers.setUserPreferences(this, "showThisYearGroups", this.showThisYearGroups);
        // storeHelpers.setGroups(this, this.groups)
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.group {
  text-align: left;
  border-bottom: 1px solid #eee;
  height: 70px;
  position: relative;
  .unread {
    // width: 13px !important;
    // height: 13px !important;
    // border-radius: 50%;
    // background: $primary-color;
    // bottom: 28px;
    // right: 20px;
    // color: $lightest-font-color;
    // padding: 0 5px 10px 5px;
    // float: right;
    // position: absolute;
    // -webkit-box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
    // -moz-box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
    // box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
    position: absolute;
    right: 5px;
    color: $lightest-font-color;
    padding: 5px 5px 24px 5px;
    height: 25px;
    font-size: 10pt;
    min-width: 24px;
    text-align: center; 
  }
}

.group-name {
  max-width: calc(100% - 40px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group:hover {
  background: $background-color-dark;
  cursor: pointer;
}

.group span {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-top: 22px;
}

.group-color {
  width:10px;
  height:100%;
  background: black;
  display: inline-block;
}

.modal-content {
  width: 40%;
}

.checkboxLabel {
  padding-left: 15px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
}

.checkboxBox {
  float: left;
}


</style>